












import { defineComponent, provide, useContext } from '@nuxtjs/composition-api';
import CategoryPage from './-category.vue';
import ProductPage from './-product.vue';
import { useCategories } from '~/features/categories';
import { useProduct } from '~/features/product';
import { CATEGORY_CONTEXT, PRODUCT_CONTEXT } from '~/utils/provides';

export default defineComponent({
  name: 'PageResolver',
  /**
   * Prevents re-rendering if the path is a variant of a product
   */
  key(route) {
    const parts = route.params.pathMatch.split('/');

    // is variant path
    if (parts.includes('var') || parts.length === 1) {
      return parts[0];
    }

    if (parts.length > 1) {
      return parts[parts.length - 1];
    }

    return route.fullPath;
  },
  components: {
    CategoryPage,
    ProductPage,
  },
  setup() {
    const { params } = useContext();
    const { findBySlug } = useCategories();
    const [categorySlug] = params.value.pathMatch.split('/').reverse();
    const category = findBySlug(categorySlug);
    if (category) {
      provide(CATEGORY_CONTEXT, category);
      return {
        type: 'category',
      };
    }

    const parts = params.value.pathMatch.split('/');
    const { product } = useProduct(parts[0]);
    provide(PRODUCT_CONTEXT, product);

    return {
      type: 'product',
    };
  },
  head: {},
});
